import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { Badge } from '@proerp/ui';
import { formatDate } from '@/lib/format';
import { formatMoney } from '@/lib/money';
import { useOpenItems } from '@/features/accounting/accountingApi';
import { TaskCard, TaskRow } from './TaskCard';

/** Überfällige Rechnungen. Finanz-Widget — nur mit dashboard.viewfinancials (Registry). */
export function OverdueInvoicesWidget() {
  const navigate = useNavigate();
  const openItems = useOpenItems();
  const overdue = (openItems.data?.data ?? []).filter((item) => item.isOverdue);

  return (
    <TaskCard
      title="Überfällige Rechnungen"
      icon={AlertTriangle}
      isLoading={openItems.isLoading}
      isEmpty={overdue.length === 0}
      emptyText="Keine überfälligen Rechnungen."
    >
      {overdue.slice(0, 6).map((item) => (
        <TaskRow
          key={item.invoiceId}
          onClick={() => navigate(`/verkauf/${item.invoiceId}`)}
          left={
            <>
              <span className="font-mono text-xs text-muted-foreground">{item.number}</span>
              <span className="ml-2 text-foreground">{item.partyName}</span>
            </>
          }
          right={
            <span className="flex items-center gap-2">
              <span className="tabular-nums text-foreground">{formatMoney(item.open)}</span>
              {item.dueDate && <Badge tone="danger">seit {formatDate(item.dueDate)}</Badge>}
            </span>
          }
        />
      ))}
    </TaskCard>
  );
}
